import doNothing from '@opsbase/lib-general/utils/doNothing';
import Palette from '@opsbase/lib-palette';
import useCallforward from '@opsbase/react-hooks/useCallforward';
import CheckIcon from '@opsbase/web-icons/icons/CheckIcon';
import PreviewIcon from '@opsbase/web-icons/icons/PreviewIcon';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Vertical from '@opsbase/web-layout/Vertical';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback, useState } from 'react';
import OpTemplateViewDialog from '../../../opsbase/dialogs/optemplate/OpTemplateViewDialog';
export function TemplateList(props) {
    const { data = [], selected = [], onSelect = doNothing } = props;
    const [templateId, setTemplateId] = useState();
    const handleClose = useCallback(() => setTemplateId(null), []);
    const handleClick = useCallforward(item => e => {
        e.stopPropagation();
        setTemplateId(item.id);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Vertical, { divider: true, scroll: true, style: { borderLeft: `1px solid ${Palette.InputBorderGrey.main}` } }, data.map((item, idx) => (React.createElement(Horizontal, { key: 'item' + idx, centered: true, shrink: true, padding: true, onClick: () => onSelect(item) },
            React.createElement(Vertical, null,
                React.createElement(Text, { variant: "h3" }, item.title),
                React.createElement(Text, { variant: "small" }, item.description || 'No description available')),
            React.createElement(Horizontal, { centered: true, gutter: true, shrink: true },
                !!selected.find(i => i.id === item.id) && (React.createElement(CheckIcon, { size: 20, htmlColor: Palette.primary.main })),
                React.createElement(PreviewIcon, { onClick: handleClick(item) })))))),
        templateId && React.createElement(OpTemplateViewDialog, { id: templateId, onClose: handleClose })));
}
export default TemplateList;
